import {lineLocal} from '@/api/apiPot'
export default {
  data() {
    return {};
  },
  methods: {
    /**跳转二级页面 */
    toSecPath(item) {
      console.log("跳转二级页面", item, item.path);
      // switch (item.path) {
      //   case "/GoodsList":
      //   case "/ClinicZone":
      //   case "/ApparatusZone":
      //   case "/PublicZone":
      //   case "/ChineseMedicineZone":
      //   case "/DailyZone":
      //     this.$store.dispatch("goods/setGoodListFrom", 1);
      //     this.$router.push({
      //       path: item.path,
      //       query: {
      //         t: new Date().getTime(),
      //         ...{ show_id: item.id }
      //       }
      //     });
      //     console.log("跳转二级页面", this.$route);

      //     console.log("setCurNavId ", item.id);
      //     this.$store.dispatch("setCurNavId", item.id);

      //     break;

      //   default:
      //     // 清空nav 记录
      //     this.$store.dispatch("setCurNavId", "");
      //     this.$router.push(item.path);

      //     break;
      // }
      lineLocal({ source_type: 1, source_info: item.name })
      // console.log("setCurNavId ", item.id);
      this.$store.dispatch("setCurNavId", item.id);
      // this.$store.dispatch("setCurNavId", "");
      this.$router.push(item.pc_url)
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/nav.js